import { OnlineSales } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import type { UpdateContactInfoDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/account/';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';

export const useUpdateSalesforceAccountHook = (): {
    updateSalesforceAccount: (updateContactInfoDTO: UpdateContactInfoDTO) => Promise<void>;
} => {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);

    const updateSalesforceAccount = async (
        updateContactInfoDTO: UpdateContactInfoDTO
    ): Promise<void> => {
        await OnlineSales.updateSalesforceAccountInformation(
            jobNumber,
            sessionId,
            updateContactInfoDTO
        );
    };

    return { updateSalesforceAccount };
};
